


























import { defineComponent, reactive, onMounted } from "@vue/composition-api";
import {
  CollectibleItem,
  loadCollectibleItems,
  StartHourList
} from "@/models/Collectibles";

type TimeTableRowData = {
  startHour: string;
  items: CollectibleItem[];
};

type TableOption = {
  data: TimeTableRowData[];
  striped: boolean;
  hoverable: boolean;
  'mobile-cards': boolean
};

export default defineComponent({
  setup() {
    const option = reactive<TableOption>({
      data: [],
      striped: true,
      hoverable: true,
      "mobile-cards": false
    });
    onMounted(async () => {
      const rawData = await loadCollectibleItems();
      const data: TimeTableRowData[] = [];
      for (const startHour of StartHourList) {
        const row: TimeTableRowData = {
          startHour: startHour,
          items: []
        };
        for (const item of rawData) {
          if (
            item.startHour1st == startHour ||
            item.startHour2nd == startHour
          ) {
            row.items.push(item);
          }
        }
        if (row.items.length > 0) {
          data.push(row);
        }
      }
      option.data = data;
    });
    return {
      option
    };
  }
});
